module.exports = __webpack_public_path__ + "img/wh.d2fafa1d.png";